import React, { useState } from "react";
import { Button, Form, Input, Select } from "antd";
import FilterLayout from "../../../components/FilterLayout/FilterLayout";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import {
  addPriceComma,
  checkValidEngNumbers,
  convertParamsIdToNumber,
  onChangeProvince,
} from "../../../core/utils";
import RangePicker from "../../../components/RangePicker/RangePicker";
import { useHistory, useLocation } from "react-router-dom";
import { parse } from "query-string";
import { useSelector } from "react-redux";

const BuyProductReportFilter = ({
  getBuyProductReport,
  users,
  provinces,
  cities,
  setCities,
  categories,
  form,
  setSearch,
  getUsers,
  exportBuyProductReport,
}) => {
  const { Option } = Select;
  const store = useSelector((state) => state.Store);
  const location = useLocation();
  const params = parse(location.search);
  const history = useHistory();

  const [isVisible, setIsVisible] = useState(false);

  return (
    <FilterLayout
      onSearch={getBuyProductReport}
      setSearch={setSearch}
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      reportFilter={exportBuyProductReport}
      placeHolder={
        "Search with driver name, plate number, driver mobile number or product name"
      }
    >
      <Form
        form={form}
        name="sellReportForm"
        initialValues={{
          province_id: convertParamsIdToNumber(params.province_id),
          city_id: convertParamsIdToNumber(params.city_id),
          operator_id: convertParamsIdToNumber(params.operator_id),
          product_category_id: convertParamsIdToNumber(
            params.product_category_id
          ),
          purchase_date: [
            params.purchase_start_date || null,
            params.purchase_end_date || null,
          ],
          min_product_price: params.min_product_price || null,
          max_product_price: params.max_product_price || null,
        }}
        onFinish={(values) => {
          getBuyProductReport();
          setIsVisible(false);
        }}
        requiredMark={false}
        scrollToFirstError
      >
        <FormWrapper>
          <Form.Item
            name="province_id"
            className="input-size sm:w-100 mb-10"
            colon={false}
            // rules={[
            //   {
            //     required: true,
            //     message: "استان الزامی است",
            //   },
            // ]}
          >
            <Select
              className="border-black-8 mb-10"
              showSearch
              onChange={(value) =>
                onChangeProvince(
                  value,
                  () => {
                    form.setFieldValue("province_id", value);
                    form.setFieldValue("city_id", null);
                    form.setFieldValue("operator_id", null);
                    getUsers(value, null);
                  },
                  setCities
                )
              }
              placeholder={"Province"}
            >
              <Option value={null} name="All Provinces">
                All Provinces
              </Option>
              {provinces?.map((province) => {
                return (
                  <Option key={province.id} value={province.id}>
                    {province.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          {store?.user?.user_type !== "company_employee" ? (
            <Form.Item
              name="operator_id"
              className="input-size sm:w-100 mb-10"
              colon={false}
              // rules={[
              //   {
              //     required: true,
              //     message: "کاربر الزامی است",
              //   },
              // ]}
            >
              <Select
                className="border-black-8 mb-10"
                showSearch
                optionFilterProp="name"
                onChange={(value) => form.setFieldValue("operator_id", value)}
                placeholder={"Employee"}
                value={form.getFieldValue("operator_id")}
              >
                <Option value={null}>All Employees</Option>
                {users?.map((user) => {
                  return (
                    <Option key={user?.user?.id} value={user?.user?.id}>
                      {user?.user?.fullname}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          ) : (
            <></>
          )}

          <Form.Item
            name="city_id"
            className="input-size sm:w-100 mb-10"
            colon={false}
            // rules={[
            //   {
            //     required: true,
            //     message: "شهر الزامی است",
            //   },
            // ]}
          >
            <Select
              className="border-black-8 mb-10"
              showSearch
              optionFilterProp="name"
              onChange={(value) => {
                form.setFieldValue("city_id", value);
                form.setFieldValue("operator_id", null);
                getUsers(form.getFieldValue("province_id"), value);
              }}
              placeholder={"City"}
            >
              <Option name="All Cities" value={null}>
                All Cities
              </Option>
              {cities?.map((city) => {
                return (
                  <Option key={city?.id} value={city?.id}>
                    {city?.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            className="input-size sm:w-100"
            style={{ marginBottom: "10px" }}
            name="purchase_date"
            colon={false}
          >
            <RangePicker
              className="border-black-8 h-45px border-radius-main"
              currentRange={
                params.purchase_start_date && params.purchase_end_date
                  ? [params.purchase_start_date, params.purchase_end_date]
                  : []
              }
              onGetRange={(value) => form.setFieldValue("purchase_date", value)}
            />
          </Form.Item>

          <Form.Item
            name="product_category_id"
            className="input-size sm:w-100 mb-10"
            colon={false}
            // rules={[
            //   {
            //     required: true,
            //     message: "دسته بندی محصول الزامی است",
            //   },
            // ]}
          >
            <Select
              className="border-black-8 mb-10"
              showSearch
              optionFilterProp="name"
              onChange={(value) =>
                form.setFieldValue("product_category_id", value)
              }
              placeholder={"Product Category"}
            >
              <Option value={null} name="All Categories">
                All Categories
              </Option>
              {categories.map((category) => {
                return (
                  <Option key={category?.id} value={category?.id}>
                    {category?.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          {store?.user?.user_type !== "company_employee" ? <div /> : null}
          <Form.Item
            name="min_product_price"
            className="input-size sm:w-100 mb-10"
            colon={false}
          >
            <Input
              type="text"
              onKeyDown={checkValidEngNumbers}
              placeholder="Min Price:"
              className="border-block-8 mb-10"
              onChange={(e) => {
                form.setFieldValue(
                  "min_product_price",
                  addPriceComma(e.target.value)
                );
              }}
            />
          </Form.Item>
          <Form.Item
            name="max_product_price"
            className="input-size sm:w-100 mb-10"
            colon={false}
          >
            <Input
              type="text"
              onKeyDown={checkValidEngNumbers}
              placeholder="Max Price:"
              className="border-block-8 mb-10"
              onChange={(e) => {
                form.setFieldValue(
                  "max_product_price",
                  addPriceComma(e.target.value)
                );
              }}
            />
          </Form.Item>
          <Button
            className="button-red input-size sm:w-100 "
            onClick={() => {
              history.push(window.location.pathname);
              setSearch("");
              setIsVisible(false);
              setTimeout(() => {
                form.resetFields();
                form.submit();
              }, 100);
            }}
          >
            Reset Filters
          </Button>

          <Button
            className="button-secondary input-size mb-10 sm:w-100"
            htmlType="submit"
            //   onClick={getServiceCenterStocks}
          >
            Filter
          </Button>
        </FormWrapper>
      </Form>
    </FilterLayout>
  );
};

export default BuyProductReportFilter;
